import React from 'react';
export function Footer() {
  return <footer className="w-full bg-gray-900 text-white py-12 px-4 sm:px-6 lg:px-8" data-id="element-63">
      <div className="max-w-6xl mx-auto" data-id="element-64">
        <div className="text-center mb-6" data-id="element-65">
          <p className="text-xl font-semibold mb-2" data-id="element-66">
            © VitaCognitiva — Tutti i diritti riservati
          </p>
          <p className="text-base text-gray-400" data-id="element-67">
            Accesso immediato via e-mail · Pagamento sicuro
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-6 text-base" data-id="element-68">
          <a href="#privacy" className="text-gray-400 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 rounded px-2 py-1" data-id="element-69">
            Privacy
          </a>
          <span className="text-gray-600" data-id="element-70">·</span>
          <a href="#termini" className="text-gray-400 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 rounded px-2 py-1" data-id="element-71">
            Termini
          </a>
          <span className="text-gray-600" data-id="element-72">·</span>
          <a href="#contatti" className="text-gray-400 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 rounded px-2 py-1" data-id="element-73">
            Contatti
          </a>
        </div>
      </div>
    </footer>;
}